import { render, staticRenderFns } from "./ModalContact.vue?vue&type=template&id=ebcb66f4&"
import script from "./ModalContact.vue?vue&type=script&lang=js&"
export * from "./ModalContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports